import React from "react";
const Toss = ({
  eventDetails,
  tossData,
  setBetSlipDetails,
  getBetPlaceSessionList,
  userInfo
}) => {
  //console.log("tossData->", tossData);

  const showBetSlip = (betType, teamName, sid, rate, price, sectionId) => {
    setBetSlipDetails({
      bet_type: betType,
      runnername: teamName,
      sid: sid,
      odds: rate,
      amount: 0,
      price: price,
      market_type: "toss_fancy",
      sectionId: sectionId
    });

    console.log("getBetPlaceSessionList->", getBetPlaceSessionList);
  };

  const getSessionBook = (marketid) => {
    let returnArr = "";
    const savedData = getBetPlaceSessionList;

    if (savedData !== null && savedData.length > 0) {
      let bookAmt = [];
      for (let i = 0; i < savedData.length; i++) {
        let obj = savedData[i];
        let key = obj.key;

        if (
          key !== undefined &&
          key !== null &&
          key === marketid + "_" + userInfo?._id
        ) {
          let values = obj.value;
          Object.values(values).map((value) => bookAmt.push(value));
          const min = Math.min(...bookAmt);
          const max = Math.max(...bookAmt);
          returnArr = (
            <span>
              <span
                style={{
                  color: "#f00",
                  fontWeight: "bold",
                  paddingLeft: "0px",
                  fontSize: "15px"
                }}
              >
                {min}
              </span>
              /
              <span
                style={{
                  color: "#00b181",
                  fontWeight: "bold",
                  paddingLeft: "8px",
                  fontSize: "15px"
                }}
              >
                {max}
              </span>
            </span>
          );
        }
      }
    }
    return returnArr;
  };
  return (
    <div style={{ display: "block" }}>
      <div className="table-box-body">
        <div className="tb-content">
          <div className="market-titlebar">
            <p className="market-name">
              <span className="market-name-badge">
                <i className="market-name-icon">
                  <img
                    src="/assets/images/time-img.png"
                    style={{
                      filter: "invert(100%)",
                      marginTop: "-8px",
                      marginLeft: "-1px"
                    }}
                  />
                </i>
                <span>Toss Market (MaxBet: 200K)</span>{" "}
                <span style={{ textTransform: "initial" }}></span>
              </span>{" "}
              <span className="rules-badge">
                <i className="fa fa-info-circle"></i>
              </span>
            </p>
            <div className="market-overarround">
              <span></span>
              <strong>BACK</strong>
            </div>
            <div className="market-overarround market-overarround-lay">
              <strong>LAY</strong>
            </div>
          </div>

          <div className="market-runners">
            {tossData !== null &&
              tossData !== undefined &&
              tossData !== "" &&
              tossData.map((toss) => (
                <div className="runner-runner">
                  <h3 className="runner-name">
                    <div className="runner-info">
                      <span className="clippable runner-display-name">
                        <h4
                          className="clippable-spacer"
                          style={{
                            fontWeight: "normal",
                            textTransform: "capitalize",
                            wordWrap: "break-word",
                            whiteSpace: "break-spaces",
                            lineHeight: "21px",
                            fontSize: "15px",
                            fontWeight: "600"
                          }}
                        >
                          {toss.market}
                          {getSessionBook(toss.marketid)}
                        </h4>
                      </span>
                    </div>
                  </h3>

                  <div className="price-row-box-new">
                    <a
                      className="price-price price-lay"
                      style={{ background: "#e8f6fc" }}
                    >
                      &nbsp;
                    </a>
                    <a
                      className="price-price price-lay mr-4"
                      style={{ background: "#e8f6fc" }}
                    >
                      &nbsp;
                    </a>

                    <a
                      onClick={() =>
                        showBetSlip(
                          "b",
                          toss.market,
                          toss.marketid,
                          toss.bak,
                          100,
                          toss.sectionId
                        )
                      }
                      className="price-price price-back mb-show"
                      style={{
                        backgroundColor: "rgb(141, 210, 240)",
                        textDecoration: "none",
                        color: "black"
                      }}
                    >
                      <div>
                        <span className="price-odd">{toss.bak}</span>
                      </div>
                    </a>
                    <a
                      className="price-price price-lay mb-show ml-4"
                      style={{
                        backgroundColor: "rgb(254, 175, 178)",
                        textDecoration: "none",
                        color: "black"
                      }}
                      href="javascript:void(0)"
                    ></a>
                    <a
                      className="price-price price-back"
                      style={{ background: "#fce3e4" }}
                    >
                      &nbsp;
                    </a>
                    <a
                      className="price-price price-back"
                      style={{ background: "#fce3e4" }}
                    >
                      &nbsp;
                    </a>

                    <div
                      className="suspended-overlap"
                      style={{
                        display: toss.mid_stat === "OPEN" ? "none" : ""
                      }}
                    >
                      Suspended
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Toss;